import { render } from "./ArticleAdsCard.vue?vue&type=template&id=f4966592&scoped=true"
import script from "./ArticleAdsCard.vue?vue&type=script&lang=js"
export * from "./ArticleAdsCard.vue?vue&type=script&lang=js"

import "./articleAdsCartStyle.scss?vue&type=style&index=0&id=f4966592&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4966592"]])

export default __exports__